import React from "react";
import { Link, useLocation } from "react-router-dom";
import navigationItems from "../../utils/constants/NavigationItems";

const ProviderLoginMenuItems = () => {
  const user = localStorage.getItem("userID");
  const location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);
  let isMeragoAI = queryParams.get("meragoai") === "true";

  let isUrl = "https://static.meragoapp.com/meragotest/merago-ai-hero.png";
  const isScribeAi = queryParams.get("scribeai") === "true";

if (isScribeAi) {
  isMeragoAI = true;
  isUrl = "https://static.meragoapp.com/meragotest/merago_ai_scribe2.png";
 
}
  console.log("isMeragoAI", isMeragoAI);

  return (
    <div>
      {!user && (
         <div className="navbar__login__screen">
              <div className="navbar__logo">
                <img
                  src="https://storage.merago.com/clinic/images/merago.png"
                  alt="logo"
                  width="145px"
                  height="45px"
                />
              </div>
              {!location?.pathname?.includes("guest") &&
                !location?.pathname?.includes("agent") &&
                !location?.pathname?.includes("nurse") && (
                  <div className="navbar__single">
                    {/* {navigationItems.loginMenu.map((items) => (
                      <Link
                        key={items.text}
                        to={items.to}
                        className={
                          location.pathname.includes(items.to)
                            ? "navbar_active"
                            : ""
                        }
                      >
                        {items.name}
                      </Link>
                    ))} */}
                  </div>
                )}
            </div>
        // <>
        //   {isMeragoAI ? (
        //     <div className="navbar__login__screen_video">
        //       <div
        //         style={{
        //           display: "flex",
        //           flexDirection: "column", // 👈 makes children vertical
        //           alignItems: "center", // 👈 center horizontally
        //           height: "70px",
        //           justifyContent: "center", // 👈 center vertically in 70px height
        //         }}
        //       >
        //         <div
        //           style={{
        //             display: "flex",
        //             justifyContent: "center",
        //           }}
        //         >
        //           <img
        //             src = {isUrl}
        //             alt="Welcome"
        //             className="register__text"
        //             style={{
        //                width: isScribeAi
        //                 ? "320px"
        //                 : "180px",
                     
        //               marginTop: "10px",
        //               height: "48px",
        //             }}
        //           />
        //         </div>

        //         <p
        //           className="register__text"
        //           style={{ color: "#557876", fontSize: "16px", margin: 0 }}
        //         >
        //           Your intelligent virtual assistant​
        //         </p>
        //       </div>
        //     </div>
        //   ) : (
        //     <div className="navbar__login__screen">
        //       <div className="navbar__logo">
        //         <img
        //           src="https://storage.merago.com/clinic/images/mhlogoTrans.png"
        //           alt="logo"
        //           width="185px"
        //           height="45px"
        //         />
        //       </div>
        //       {!location?.pathname?.includes("guest") &&
        //         !location?.pathname?.includes("agent") &&
        //         !location?.pathname?.includes("nurse") && (
        //           <div className="navbar__single">
        //             {/* {navigationItems.loginMenu.map((items) => (
        //               <Link
        //                 key={items.text}
        //                 to={items.to}
        //                 className={
        //                   location.pathname.includes(items.to)
        //                     ? "navbar_active"
        //                     : ""
        //                 }
        //               >
        //                 {items.name}
        //               </Link>
        //             ))} */}
        //           </div>
        //         )}
        //     </div>
        //   )}
        // </>
      )}
    </div>
  );
};

export default ProviderLoginMenuItems;
